/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;max-width:600px;margin:0 auto}p[_ngcontent-%COMP%]{padding:18px 30px;font-size:14px;line-height:1.4;color:#444}"];
export { styles as styles };
